import React from 'react';
interface ActionButtonProps {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary' | 'ghost';
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
}
export const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  onClick,
  variant = 'primary',
  disabled = false,
  className = '',
  icon
}) => {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variantStyles = {
    primary: 'bg-[#005a9e] text-white hover:bg-[#004a85] focus:ring-[#005a9e]',
    secondary: 'bg-white text-[#005a9e] border border-[#005a9e] hover:bg-[#f0f7ff] focus:ring-[#005a9e]',
    ghost: 'bg-transparent text-[#333333] hover:bg-[#f5f6f8] focus:ring-gray-300'
  };
  const disabledStyles = 'opacity-50 cursor-not-allowed';
  return <button onClick={onClick} disabled={disabled} className={`
        ${baseStyles}
        ${variantStyles[variant]}
        ${disabled ? disabledStyles : ''}
        ${className}
      `} data-id="element-13">
      {icon && <span className="mr-2" data-id="element-14">{icon}</span>}
      {label}
    </button>;
};